<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="预约信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{appointmentOrderVO.billNo}}</td>
            <td class="tableLabel">登记人：</td>
            <td>{{appointmentOrderVO.creatorName}}</td>
            <td class="tableLabel">提交时间：</td>
            <td>{{appointmentOrderVO.submitTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预约日期：</td>
            <td>{{appointmentOrderVO.appointmentTime}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{appointmentOrderVO.factoryNo}}</td>
            <td class="tableLabel">现场名称：</td>
            <td>{{appointmentOrderVO.siteName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称：</td>
            <td>{{appointmentOrderVO.customerName}}</td>
            <td class="tableLabel">销售员：</td>
            <td>{{appointmentOrderVO.salesmanName}}</td>
            <td class="tableLabel">销售联系方式：</td>
            <td>{{appointmentOrderVO.salesMobile}}</td>
          </tr>
          <tr>
            <td class="tableLabel">现场联系人：</td>
            <td>{{appointmentOrderVO.contact}}</td>
            <td class="tableLabel">现场联系方式：</td>
            <td>{{appointmentOrderVO.siteMobile}}</td>
            <td class="tableLabel">项目负责人：</td>
            <td>{{appointmentOrderVO.projectLeader}}</td>
          </tr>
          <tr>
            <td class="tableLabel">服务台数：</td>
            <td>{{appointmentOrderVO.serviceQuantity}}</td>
            <td class="tableLabel">主板型号：</td>
            <td>{{appointmentOrderVO.mainBoardModel}}</td>
            <td class="tableLabel">变频器型号：</td>
            <td>{{appointmentOrderVO.transducerModel}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预估完成工时：</td>
            <td>
              <el-input v-model="appointmentOrderVO.estimatedFinishTime"/>
            </td>
            <td class="tableLabel">实际完成时间：</td>
            <td>
              <el-input v-model="appointmentOrderVO.actualFinishTime" disabled/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">服务地址：</td>
            <td colspan="5">{{appointmentOrderVO.serviceAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">故障描述：</td>
            <td colspan="5">{{appointmentOrderVO.faultNote}}</td>
          </tr>
          <tr>
            <td class="tableLabel">主板型号：</td>
            <td>{{appointmentOrderVO.mainBoardModel}}</td>
            <td class="tableLabel">变频器型号：</td>
            <td>{{appointmentOrderVO.transducerModel}}</td>
            <td class="tableLabel">控制柜编号：</td>
            <td>{{appointmentOrderVO.kzgNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">序列号：</td>
            <td>{{appointmentOrderVO.machineSerialNo}}</td>
            <td class="tableLabel">问题分类：</td>
            <td>
              <el-select v-model="appointmentOrderVO.questionType" disabled placeholder="请选择">
                <el-option label="错" :value="1"/>
                <el-option label="漏" :value="2"/>
                <el-option label="质量" :value="3"/>
                <el-option label="运输损坏" :value="4"/>
                <el-option label="其他" :value="5"/>
              </el-select>
            </td>
            <td class="tableLabel">责任部门：</td>
            <td>{{appointmentOrderVO.responsibilityDepartment}}</td>
          </tr>
          <tr>
            <td class="tableLabel">到场时间：</td>
            <td>{{appointmentOrderVO.arrivalTime}}</td>
            <td class="tableLabel">离场时间：</td>
            <td>{{appointmentOrderVO.leaveTime}}</td>
            <td class="tableLabel">是否收费：</td>
            <td>{{appointmentOrderVO.isCharge?"是":"否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任判定：</td>
            <td>
              <el-select v-model="appointmentOrderVO.responsibilityDecide" disabled placeholder="请选择">
                <el-option label="客户要求配合(收费)" :value="2"/>
                <el-option label="客户工地原因(收费)" :value="21"/>
                <el-option label="客户要求配合(不收费)" :value="22"/>
                <el-option label="我司供应商原因(不收费)" :value="3"/>
                <el-option label="我司生产原因(不收费)" :value="31"/>
                <el-option label="我司其它原因(不收费)" :value="32"/>
                <el-option label="我司研发待分析(不收费)" :value="4"/>
              </el-select>
            </td>
            <td class="tableLabel">指定调试人员：</td>
            <td>{{appointmentOrderVO.debugName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">现场情况描述：</td>
            <td colspan="5">{{appointmentOrderVO.siteDescription}}</td>
          </tr>
          <tr>
            <td class="tableLabel">维修过程：</td>
            <td colspan="5">{{appointmentOrderVO.maintainNote}}</td>
          </tr>
          <tr>
            <td class="tableLabel">设备/行业:</td>
            <td colspan="5">
              <el-radio-group v-model="appointmentOrderVO.equipmentType" disabled>
                <el-radio label="3C电子">3C电子</el-radio>
                <el-radio label="半导体">半导体</el-radio>
                <el-radio label="光伏/锂电">光伏/锂电</el-radio>
                <el-radio label="机床/激光">机床/激光</el-radio>
                <el-radio label="火花机/线切割">火花机/线切割</el-radio>
                <el-radio label="包装/印刷">包装/印刷</el-radio>
                <el-radio label="纺织">纺织</el-radio>
                <el-radio label="机器人">机器人</el-radio>
                <el-radio label="物流">物流</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">产品类型:</td>
            <td colspan="5">
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems3" disabled>
                <el-checkbox v-for="item in appointmentItemTemplates3" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>

          <tr>
            <td class="tableLabel">服务性质:</td>
            <td colspan="5">
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems1" disabled>
                <el-checkbox v-for="item in appointmentItemTemplates1" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">服务原因:</td>
            <td colspan="5">
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems2" disabled>
                <el-checkbox v-for="item in appointmentItemTemplates2" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="报价处理">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">客户意见：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCustomerAgree" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">不同意原因：</td>
            <td>
              <el-input v-model="appointmentOrderVO.disagreeReasons" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">收费订单号：</td>
            <td>
              <el-input v-model="appointmentOrderVO.chargeOrderNo" placeholder="请输入" type="textarea"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否收费：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCharge" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">要求收费日期：</td>
            <td>
              <el-date-picker
                  v-model="appointmentOrderVO.chargeDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">报价单信息</div>
          <el-button v-if="updatePriceSheetsAuth" type="primary" style="margin-bottom: 10px" @click="$refs.addPriceSheet.open(-1,null)">
            新建
          </el-button>
          <el-button
              v-if="updatePriceSheetsAuth"
              :loading="saveLoading"
              style="margin-bottom: 5px"
              type="primary"
              @click="savePriceSheets">
            保存
          </el-button>
          <el-table
              ref="payData1"
              :data="appointmentOrderVO.appointmentPriceSheets">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="项目名称"/>
            <el-table-column prop="serviceContent" align="center" label="服务内容"/>
            <el-table-column prop="chargeReason" align="center" label="收费原因"/>
            <el-table-column prop="price" align="center" label="价格"/>
            <el-table-column prop="note" align="center" label="备注"/>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="120px">
              <template slot-scope="scope">
                <el-button v-if="updatePriceSheetsAuth" type="primary" @click="$refs.addPriceSheet.open(scope.$index,scope.row)">编辑</el-button>
                <el-button v-if="updatePriceSheetsAuth" type="danger" @click="oneDeletePriceSheet(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="收费确认">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">客户意见：</td>
            <td>{{appointmentOrderVO.isCustomerAgree?"是":"否"}}</td>
            <td class="tableLabel">不同意原因：</td>
            <td>{{appointmentOrderVO.disagreeReasons}}</td>
            <td class="tableLabel">收费订单号：</td>
            <td>{{appointmentOrderVO.chargeOrderNo}}</td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">申请延期</div>
          <el-table
              ref="yqDate">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="审批人"/>
            <el-table-column prop="serviceContent" align="center" label="申请延期时间"/>
            <el-table-column prop="chargeReason" align="center" label="申请时间"/>
            <el-table-column prop="price" align="center" label="申请人"/>
            <el-table-column prop="note" align="center" label="审批意见"/>
            <el-table-column prop="note" align="center" label="备注"/>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane name="three" label="服务评价">
        <el-rate
            v-model="appointmentOrderVO.serviceScore"
            show-text
            :texts="texts"/>
      </el-tab-pane>
    </el-tabs>

    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="appointmentOrderVO.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">现场照片</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.siteAttachments"
            :key="item"
            style="width: 100px; height: 100px;margin-right: 10px"
            :src="item"
            :preview-src-list="srcList"/>
      </div>
    </div>

    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">客户签名</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.signatureAttachments"
            :key="item"
            style="width: 100px; height: 100px;border: 1px solid #ccc;border-radius: 5px;margin-right: 10px"
            :src="item"
            :preview-src-list="srcList"/>
      </div>
    </div>
    <add-price-sheet ref="addPriceSheet" @save-success="addPriceSheets"/>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import AddPriceSheet from "@/views/AfterSaleManage/AppointmentOrder/AddPriceSheet";
  export default {
    name:"AppointmentPreview",
    components:{HandleDetail,AddPriceSheet},
    data() {
      return {
        srcList:[],
        billId:"",
        billType:"15",
        pkid:"",
        saveLoading: false,
        updatePriceSheetsAuth: this.$auth(904),
        imgUrls: [],
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        appointmentItemTemplates3: [],
        texts: ["非常不满意", "不满意", "基本满意", "满意", "非常满意"],
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: "",
          debugName: "",
          customerId: "",
          customerName: "",
          salesmanId: "",
          salesmanName: "",
          salesMobile: "",
          salesOrderNo: "", //出厂编号
          siteName: "",
          contact: "",
          siteMobile: "",
          natureNote: "",
          projectLeader: "",
          serviceAddress: "", //服务地址
          serviceQuantity: "", //服务台数
          submitTime: "", //提交日期
          siteDescription: "", //审核意见
          responsibilityDecide: "", //审核意见
          questionType: "", //审核意见
          mainBoardModel: "",
          transducerModel: "",
          causeNote: "",
          faultNote: "",
          isCharge: "",
          chargeDate: "",
          disagreeReasons: "",
          isCustomerAgree: "",
          chargeOrderNo: "",
          isDeferred: "",
          deferredTime: "",
          arrivalTime: "",
          leaveTime: "",
          maintainNote: "",
          serviceScore: "",
          serviceResult: "",
          responsibilityDepartment: "",
          attachments: [],
          siteAttachment: [],
          signatureAttachments: [],
          delayTableData: [],
          appointmentItems1: [],
          appointmentItems2: [],
          appointmentPriceSheets: [],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
      this.getTemplateList();
    },
    destroyed() {
      this.billId = "";
      this.appointmentOrderVO={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`appointmentOrders/${this.billId}`).then((res)=>{
          this.appointmentOrderVO = res.data;
          this.appointmentOrderVO.siteAttachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
          this.appointmentOrderVO.signatureAttachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
          this.appointmentOrderVO.attachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
        }).catch(()=>{
        });
      },
      addPriceSheets(row,index) {
        console.log(row,index);
        if (index>=0) {
          this.appointmentOrderVO.appointmentPriceSheets[index] = row;
        }else {
          this.appointmentOrderVO.appointmentPriceSheets.push(row);
        }

      },
      oneDeletePriceSheet(index) {
        this.appointmentOrderVO.appointmentPriceSheets.splice(index, 1);
      },
      savePriceSheets() {
        this.appointmentOrderVO.siteAttachments=[];
        this.appointmentOrderVO.signatureAttachments=[];
        this.saveLoading = true;
        this.$http
          .put("basic", "appointmentOrders/updatePriceSheets",this.appointmentOrderVO)
          .then(() => {
            this.saveLoading = false;
            this.$message.success("保存成功");
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentItemTemplates/getAllList")
          .then(resp => {
            this.appointmentItemTemplates1 = [];
            this.appointmentItemTemplates2 = [];
            resp.data.forEach(item=>{
              if (item.itemType === 10) {
                this.appointmentItemTemplates1.push(item);
              }else if (item.itemType === 20) {
                this.appointmentItemTemplates2.push(item);
              }else {
                this.appointmentItemTemplates3.push(item);
              }
            });
          });
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
    },
  };
</script>

<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
